import { Injectable } from '@angular/core';
import { AngularFirestore, CollectionReference, DocumentReference } from '@angular/fire/compat/firestore';
import { Card } from '../models/card.model';
import { Logger } from '../logger.service';

const log = new Logger('card-service');

@Injectable({
  providedIn: 'root',
})
export class CardService {
  private collection: CollectionReference<Card>;

  constructor(private firestore: AngularFirestore) {
    this.collection = this.firestore.collection<Card>('cards').ref;
  }

  // Obtener todos los elementos
  async getAll(): Promise<Card[]> {
    const snap = await this.collection.get();
    const data = snap.docs.map((o) => {
      return { uid: o.id, ...o.data() };
    });
    return data;
  }

  // Obtener un elemento por ID
  async getById(uid: string): Promise<Card | null> {
    const snap = await this.collection.doc(uid).get();
    if (snap.exists) {
      const data = { uid: snap.id, ...snap.data() } as Card;
      return data;
    } else {
      return null;
    }
  }

  // Crear un nuevo elemento
  async create(item: Card): Promise<DocumentReference<Card>> {
    return await this.collection.add(item);
  }

  // Actualizar un elemento
  async update(uid: string, item: Card): Promise<void> {
    await this.collection.doc(uid).update(item);
  }

  // Eliminar un elemento
  async delete(uid: string): Promise<void> {
    await this.collection.doc(uid).delete();
  }

  async getByUserId(userId: string): Promise<Card[]> {
    try {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const ref = this.firestore.collection('customers').doc(userId);
      const snap = await this.collection.where('customer', '==', ref).get();
      if (snap.size) {
        snap.docs.map((d) => {
          return {
            ...d.data(),
            id: d.id,
          } as Card;
        });
      }
    } catch (error) {
      log.error(error);
    }
    return [];
  }

  async getByUserIdLast24Hours(userId: string): Promise<Card[]> {
    try {
      const yesterday = new Date();
      yesterday.setDate(yesterday.getDate() - 1);
      const snap = await this.collection.where('userId', '==', userId).where('createdAt', '>=', yesterday).get();
      if (snap.size) {
        snap.docs.map((d) => {
          return {
            ...d.data(),
            id: d.id,
          } as Card;
        });
      }
    } catch (error) {
      log.error(error);
    }
    return [];
  }
}
